@if (showLoading()) {
<div
  class="z-99999 fixed top-0 left-0 flex min-h-screen w-full flex-col items-center justify-center gap-12 bg-background text-muted-foreground">
  <div class="flex flex-col items-center gap-10" role="status" aria-live="polite">
    <div class="flex flex-col items-center gap-4">
      <img ngSrc="assets/logo/RITMOS_HORIZONT_ESCURO.svg" priority width="564" height="197" alt="Ritmos Insight"
        class="h-20 w-auto dark:hidden md:h-24" />
      <img ngSrc="assets/logo/RITMOS_HORIZONT_CLARO.svg" priority width="564" height="197" alt="Ritmos Insight"
        class="hidden h-20 w-auto dark:block md:h-24" />
    </div>
    <div class="flex flex-col items-center gap-3">
      <svg class="h-12 w-12 animate-spin text-primary" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-80" fill="currentColor" d="M4 12a8 8 0 0 1 8-8v4a4 4 0 0 0-4 4H4z"></path>
      </svg>
      <span class="text-sm font-medium tracking-wide text-muted-foreground">{{
        'features.initial-loading.loading' | translate }}</span>
    </div>
    <span class="sr-only">{{ 'features.initial-loading.loadingAria' | translate }}</span>
  </div>
</div>
}



